import styled from 'styled-components';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _noop from 'lodash/noop';

import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';

import Container from '../../containers/ShareButton';

const ShareButton = styled(Container).attrs((props) => ({
    iconName: 'share-square-2',
    iconSize: 22,
    size: 'sm',
    styleName: 'default',
    ...props,
}))`
    span {
        vertical-align: middle;
    }
    ${IconWrapper} {
        padding-top: 0;
        vertical-align: middle;
        stroke: none;
    }
`;

ShareButton.propTypes = {
    mediaId: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    labelKey: PropTypes.string,
    shape: PropTypes.string,
};

ShareButton.defaultProps = {
    onClick: _noop,
    labelKey: 'share_text',
    shape: 'hollow',
};

export default ShareButton;
